import React from 'react'
import BestSeller from './BestSeller/BestSeller'
import Ads from './Ads/Ads'
import Support from './Support/Support'
import News from './News/News'
import Featured from './Featured/Featured'
export default function Main() {
  return (
    <>
    <BestSeller />
    <Ads />
    <Support />
    <News />
    <Featured />
    </>
  )
}
